import SocialLogin from "./social-login/SocialLogin";
import ConsentWidget from "./consent-widget/ConsentWidget";
import Deeplink from "./deeplink/Deeplink";
import EmailVerification from "./email-verification/EmailVerification";
import HiddenFields from "./hidden-fields/HiddenFields";
import Preregistration from "./preregistration/Preregistration";
import TransactionalEmails from "./transactional-emails/TransactionalEmails";
import EmailChange from "./email-change/EmailChange";
import CustomValidation from "./custom-validation/CustomValidation";
import CustomSpecialisationOptions from "./custom-specialisation-options/CustomSpecialisationOptions";
import LanguageSelector from "./language-selector/LanguageSelector";
import ChangePassword from "./change-password/ChangePassword";
import EditProfileAccess from "./edit-profile-access/EditProfileAccess";

export default {
  SocialLogin,
  ConsentWidget,
  Deeplink,
  EmailVerification,
  HiddenFields,
  Preregistration,
  TransactionalEmails,
  EmailChange,
  CustomValidation,
  CustomSpecialisationOptions,
  LanguageSelector,
  ChangePassword,
  EditProfileAccess
};
